import React, { useState } from 'react';
import { Button, ButtonGroup } from '@chakra-ui/react';

const filterValues = (isMatch: boolean): string[] => {
  return isMatch ? [`${isMatch}`] : [];
};

const options = [
  { value: false, label: 'Match any' },
  { value: true, label: 'Match all' },
];

export const MatchAnyOrAll = ({
  filterName,
  isMatchAll,
  saveFilter,
}: {
  saveFilter: (key: string, values: string[] | number[]) => void;
  filterName: string;
  isMatchAll: boolean;
}): React.ReactElement => {
  const [matchValue, setMatchValue] = useState(isMatchAll);

  const onChangeHandler = (): void => {
    setMatchValue(!matchValue);
    saveFilter(filterName, filterValues(!isMatchAll));
  };

  return (
    <ButtonGroup isAttached display="flex" variant="outline" colorScheme="gray" size="sm" mb={4}>
      {options.map((option, index) => (
        <Button
          onClick={onChangeHandler}
          isActive={option.value === matchValue}
          key={`${option.value}-${index}`}
          flexGrow="1"
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};
